import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import classNames from 'classnames';
import { ScheduleCell } from 'features/schedule/ui/components/ScheduleCell';
import { translateDay } from 'features/schedule/utils';
import { useScheduleRow } from '../model';
import styles from './styles.module.scss';

export const ScheduleRow = () => {
  const {
    state: { sensors, bells, gridRows },
    methods: { handleDragEnd, handleDragStart, handleDragCancel },
  } = useScheduleRow();

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      modifiers={[restrictToVerticalAxis]}
    >
      <tbody>
        {gridRows.map(
          ({
            key,
            isFirstLessonInDay,
            isLastLessonInDay,
            isLastDay,
            day,
            startTime,
            endTime,
            cells,
          }) => (
            <tr key={key}>
              {isFirstLessonInDay && (
                <td
                  className={classNames(styles.dayCol, {
                    [styles.dayCol_last]: isLastDay,
                  })}
                  rowSpan={bells.length}
                >
                  <span className={styles.dayHeader}>{translateDay(day)}</span>
                </td>
              )}
              <td
                className={classNames(styles.lessonHeader, {
                  [styles.lessonHeader_last]: isLastLessonInDay && !isLastDay,
                })}
              >
                <span>{`${startTime}-${endTime}`}</span>
              </td>
              {cells.map(
                ({ slotKey, item, isSuggested, isError, category, errors, educationalClass }) => {
                  return (
                    <td
                      key={slotKey}
                      className={classNames(styles.subjectCell, {
                        [styles.subjectCell_last]: isLastLessonInDay && !isLastDay,
                      })}
                    >
                      <ScheduleCell
                        slotKey={slotKey}
                        item={item}
                        isSuggested={isSuggested}
                        isError={isError}
                        errorCategory={category}
                        errors={errors}
                        educationalClass={educationalClass}
                      />
                    </td>
                  );
                },
              )}
            </tr>
          ),
        )}
      </tbody>
    </DndContext>
  );
};
